import React from 'react';
import { CONTACT_INFO } from '../data/content';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  const logoSrc = `${process.env.PUBLIC_URL}/logo.png`;

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Logo */}
        <div className="footer-logo">
          <img
            src={logoSrc}
            alt="DWB Tech"
            className="footer-logo-img"
            onError={e => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div className="footer-logo-text" style={{ display: 'none' }}>
            <div className="logo-icon-sm">D</div>
            <div className="footer-brand-name">DWB<span>Tech</span></div>
          </div>
        </div>

        {/* Tagline */}
        <p className="footer-tagline">
          Global leader in PCB design, ASIC verification & semiconductor solutions.
        </p>

        {/* Contact */}
        

        {/* Social Media */}
        <div className="footer-socials">
          <a
            href="https://www.linkedin.com/company/dwbtech"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-link"
            aria-label="LinkedIn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </div>

      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        © {year} DWB Tech Solutions. All Rights Reserved.
      </div>
    </footer>
  );
}